import { PlayerLundis } from './player/player.js'
import '../scss/player-lundis-mediafaune-public.scss'

document.addEventListener('DOMContentLoaded', () => {
  const title = LundisPlayerVars.title
  const thumbnail = LundisPlayerVars.thumbnail
  const players = document.querySelectorAll('.player-lundis-mediafaune-block-player')

  const grayPlaceholder = 
    "data:image/svg+xml;utf8," +
    encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="125" height="125">
      <rect width="125" height="125" fill="#ccc"/>
    </svg>`)

  players.forEach(p => {
    const wrapper = p.querySelector('.player-lundis-wrapper')
    const container = p.querySelector('.waveform')
    const playBtn = p.querySelector('.play-pause-btn')
    const currentTimeEl = p.querySelector('.current-time')
    const durationEl = p.querySelector('.duration')
    const audioUrl = p.dataset.audio

    // Passer le wrapper pour gérer le loading par block
    const player = new PlayerLundis({
      wrapper,
      container,
      playBtn,
      currentTimeEl,
      durationEl,
      audioUrl
    })

    // Image
    const image = p.querySelector('.player-image')
    if (image) {
      const img = document.createElement('img')
      img.src = thumbnail || grayPlaceholder
      img.alt = 'Lundis-moi Tout - ' + title
      image.prepend(img)
    }
  })
})
